module.exports = __webpack_public_path__ + "img/undraw_notify_88a4.66abeee3.svg";